/**
 * 替换tab页签的icon
 * 使用异步的方式，而最简单的异步方式是设置延时器，0s后执行
 * 校验url是否存在，存在替换不存在使用默认url
 */
function checkIconURLAndReplace() {
  let url = "";
  if (location.href.indexOf("545007") >= 0 || location.href.indexOf("2l56r5") >= 0) {
    url = "https://ct-global-dev-1300343054.cos.ap-singapore.myqcloud.com/mc/1663493188379qdAQgojuSp.png";
  } else {
    return;
  }
  // 如果已经替换了，则不再重复执行
  // document.querySelector('link[rel="icon"]').href = "https://www.baidu.com/favicon.ico";
  if (document.querySelector('link[rel="icon"]').href == url) {
    return;
  }
  let checkImg = (url) => {
    var img = new Image();
    img.src = url;
    return img.height != 0;
  };
  setTimeout(() => {
    if (checkImg) {
      document.querySelector('link[rel="icon"]').href = url;
    }
  }, 10);
};

function changeTabName() {
  // 如果是妄想game8的游戏，那么名字改为
  if (location.href.indexOf("545007") >= 0 || location.href.indexOf("2l56r5") >= 0) {
    document.title = "神獣伝説〜エボリューション・ディバウア〜";
  } else {
    document.title = "Cloud Game";
  }
}

/**
 * 替换tab页签的 icon 和 名称
 */
export function changeTabIconAndName() {
  checkIconURLAndReplace();
  changeTabName();
}